export default __webpack_public_path__ + "static/media/ConfidentLoginBackground.307e8ad0.svg";